var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer",attrs:{"id":"foot2"}},[(_vm.config)?_c('div',{staticClass:"content"},[_vm._v(_vm._s(_vm.config.copyright)+" "+_vm._s(_vm.config.gxbba)+" "+_vm._s(_vm.config.ggwba))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }